import { hasPermissionsOfAll, hasPermissionsOfAtLeastOne } from "@/services/permissionService"
import { useAuthStore } from "@/store/authentication"

export const auth = {
  getUser: () => {
    const store = useAuthStore()
    return {
      email: store.getEmail,
      firstName: store.getFirstName,
      lastName: store.getLastName,
      permissions: store.getPermissions,
    }
  },
  getTenant: () => useAuthStore().getTenant(),
  getToken: () => useAuthStore().getToken(),
  // Checks if token and tenant data are stillt valid
  isLoggedIn: () => auth.getToken() && auth.getToken() !== "" && auth.getTenant() && auth.getTenant() !== "",
  hasOneOfPermissions: permissions => {
    return !!hasPermissionsOfAtLeastOne(permissions).value
  },
  hasAllOfPermissions: permissions => {
    return !!hasPermissionsOfAll(permissions).value
  },
}
